import type { DpsMiniAppBackendPeriodDto } from "@gameApp/api/types/DpsMiniAppBackend";
import {
  MINI_GAME_ORDER_TYPE_LABELS,
  MINI_GAME_ORDER_TYPE_LABELS_SHORT,
} from "@gameComponents/MiniGame/constants";

/**
 * @example
 * miniGameOrderPeriodLabel(1); // "1 Hour"
 * miniGameOrderPeriodLabel(1, true); // "1H"
 */
export function miniGameOrderPeriodLabel(
  hours: DpsMiniAppBackendPeriodDto["hours"],
  short?: boolean,
): string {
  return short
    ? MINI_GAME_ORDER_TYPE_LABELS_SHORT[hours]
    : MINI_GAME_ORDER_TYPE_LABELS[hours];
}
